import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {HashRouter, Route, Switch} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import Pick from "./components/pickStatus/Pick";
import RouteComponent from "./components/routeView/RouteComponent";
import RouteDetailComponent from "./components/routeDrillDown/RouteDetailComponent";
import AssociateList from "./components/pickStatus/AssociateList";
import AssociatesV2 from "./components/outboundassociate/AssociatesV2";
import Associate from "./components/pickassociate/Associates";
import ErrorBoundary from "./components/handler/ErrorBoundary"
import {addLocaleData, IntlProvider} from 'react-intl';
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import de from 'react-intl/locale-data/de'
import ar from 'react-intl/locale-data/ar'
import tr from 'react-intl/locale-data/tr'
import {getDirection, getLocale, getMessages} from "./handler/LocaleHandler";
import {ANALYTICS_CONFIG, EMPTY_STRING} from "./components/util/Constants";
import {DeviceLayoutProvider} from './components/common/context/DeviceLayoutContext';
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import {
  getDarkModeStatus, getUserName,
  setDarkModeStateListener,
} from "./components/handler/ParentDataHandler";
import { DARK_MODE } from "./components/util/Constants";
import {getStationCode} from "./components/network/NetworkUtil";
import {getRegion, getStage} from "./components/util/Util";
import {AlchemyAnalytics} from '@amzn/alchemy-components/dist/utils/AlchemyAnalytics.es5';
addLocaleData(en)
addLocaleData(ja)
addLocaleData(it)
addLocaleData(de)
addLocaleData(fr)
addLocaleData(es)
addLocaleData(ar)
addLocaleData(tr)

getLocale().then(locale => {
    document.getElementsByTagName('html')[0].setAttribute('dir', getDirection(locale));
    ReactDOM.render(<GetRouter locale={locale} />, document.getElementById('root'));
})

export const GetRouter = ( {locale} ) => {
    const [currentDarkMode, setCurrentDarkMode] = useState(DARK_MODE.LIGHT);

    useEffect(() => {
        setDarkModeStateListener(setCurrentDarkMode);
        getDarkModeStatus();
    }, []);
    useEffect(()=>{
        const initializePendo = async () => {
            try {
                const visitorId = (await getUserName()).split('@')[0];
                new AlchemyAnalytics({
                    apikey: ANALYTICS_CONFIG.PENDO_API_KEY,
                    account: {
                        id: ANALYTICS_CONFIG.ACCOUNT_ID
                    },
                    visitor: {
                        id: visitorId,
                        stationCode: (getStationCode() === undefined || getStationCode().stationCode === undefined) ?
                            EMPTY_STRING : getStationCode().stationCode,
                        environment: getStage(),
                        region: getRegion()

                    }
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Failed to initialize analytics');
                console.warn('Failed to initialize Pendo', error);
            }
        }
        initializePendo()
    },[])


    return (
        <Theme tokens={currentDarkMode === DARK_MODE.DARK ? blueDarkTokens : blueLightTokens} >
            <ErrorBoundary>
                <IntlProvider locale={locale} messages={getMessages(locale)}>
                    <DeviceLayoutProvider>
                        <HashRouter>
                            <Switch>
                                <Route path="/pick/:context" component={Pick} />
                                <Route path="/pick" component={Pick} />
                                <Route path="/associateList/:routeId/:routeCode/:associateList" component={AssociateList} />
                                <Route path="/outboundassociates/:associate" component={AssociatesV2} />
                                <Route path="/pickassociates/:associate" component={Associate} />
                                <Route path="/outboundassociates" component={AssociatesV2} />
                                <Route path="/pickassociates" component={Associate} />
                                <Route path="/route" component={RouteComponent} />
                                <Route
                                    path="/routeDetail/:prevTab/:routeId/:status/:location/:hazmatWeight/:associate/:code/:stationCode/:picklistId?"
                                    component={RouteDetailComponent} />
                            </Switch>
                        </HashRouter>
                    </DeviceLayoutProvider>
                </IntlProvider>
            </ErrorBoundary>
        </Theme>
    );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// WEBPACK FOOTER //
// ./src/index.js